// 园区动态
import { getYQDTList, getYQDTDetail } from '@/api'

const state = {
	parkType: 0,
	pageList: {
		totalRow: 0, //	总条数
		pageNumber: 0,
		firstPage: false,
		lastPage: false,
		totalPage: 0, //	总页数
		pageSize: 0,
		list: [
			/*
         {
                "publishrange": null,
                "yuqing_id": null,
                "img": null,
                "synWeixin": "",
                "source": "公有云",
                "type": "41582edf60644be5a6e79b439afae727",
                "title": "园区新闻测试",
                "content": "<p>23423534634564575685</p>",
                "url": null,
                "parksname": null,
                "contenturl": "/html/news/00100176014759f3f144a284569448b8447046.html",
                "parkscode": "001001",
                "attachment": "http://47.106.223.50:9091/oss/getOssFileJumping?filecode=2021-06-12-5a3b4d1a-921b-40a3-8cae-6fb47627a6c6",
                "istop": "否",
                "publishtime": "2021-06-12 15:51:35",
                "modiftime": "2021-06-12 17:33:43",
                "id": "76014759f3f144a284569448b8447046",
                "enterpriseid": null,
                "platformCode": "",
                "introduction": "124123123123",
                "toptime": null
            }
            */
		],
	},
	detail: {
		ctime: '',
		title: '',
		content: '',
	},
}
const mutations = {
	SET_PAGE_LIST(state, payload) {
		state.pageList = payload
	},
	SET_PARK_TYPE(state, payload) {
		state.parkType = payload
	},
	SET_DETAIL(state, payload) {
		state.detail = payload
	},
}
const actions = {
	fetchPageList({ commit }, payload = {}) {
		const parkType = payload.parkType || 1
		const page = payload.page || 1
		const limit = payload.limit || 10
		commit('SET_PARK_TYPE', parkType)
		getYQDTList(parkType, page, limit).then((result = {}) => {
			if (result.page) {
				commit('SET_PAGE_LIST', result.page)
			} else {
				commit('SET_PAGE_LIST', result)
			}
		})
	},
	fetchDetail({ commit }, payload) {
		const parkType = payload.parkType || 1
		const id = payload.id || ''
		getYQDTDetail(parkType, id).then((result = {}) => {
			if (result.data) {
				commit('SET_DETAIL', result.data)
			} else {
				commit('SET_DETAIL', result)
			}
		})
	},
	handleCurrentChange({ state, dispatch }, currentPage) {
		const params = {
			parkType: state.parkType,
			page: currentPage,
		}
		dispatch('fetchPageList', params)
	},
}
export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
